import { Avatar, Box, Stack, Typography } from '@mui/material';
import {
  getDisabledVeteran,
  IDisabledVeteran,
} from 'API/DisabledVeteran/disabledVeteran';
import { CustomMetaTitle, LinkReturnToMain, Loader } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import {
  useAppSelector,
  useDictionary,
  useIsDesktop,
  useDisabilityCertAccess,
} from 'Hooks';
import { DisabledVeteranBg, DisabledVeteranBgMobile } from 'Images';
import { useEffect, useState } from 'react';
import { HeaderIcons } from 'Images';
import { DisabledVeteranPaper } from './DisabledVeteranPaper';
import { DisabledVeteranNoAccess } from './DisabledVeteranNoAccess';

export const DisabledVeteran = () => {
  const [disabledVeteran, setDisabledVeteran] = useState<IDisabledVeteran>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const dictionary = useDictionary(Dictionary, DICTIONARY.DisabledVeteran);
  const isDesktop = useIsDesktop();

  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );

  const { hasAccess } = useDisabilityCertAccess();

  useEffect(() => {
    const getData = async () => {
      const data = await getDisabledVeteran();
      setIsLoading(false);
      if (data) {
        setDisabledVeteran(data);
      }
    };

    if (hasAccess) {
      getData();
    } else
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
  }, [hasAccess, imposterId]);

  if (isLoading) return <Loader />;

  if (!hasAccess) return <DisabledVeteranNoAccess />;

  return (
    <Box height={isDesktop ? undefined : '700px'}>
      <Stack
        gap={'68px'}
        marginBottom={isDesktop ? '100px' : undefined}
        position={'relative'}
        alignItems={'center'}
        height={isDesktop ? 'auto' : '760px'}
        sx={
          isDesktop
            ? undefined
            : {
                position: 'absolute',
                top: '24px',
                right: '-24px',
                width: '100vw',
              }
        }
      >
        <CustomMetaTitle title={dictionary.metaTitle} />
        {isDesktop && (
          <Stack alignSelf={'flex-start'}>
            <LinkReturnToMain />
          </Stack>
        )}
        <Stack
          position={isDesktop ? 'relative' : undefined}
          top={0}
          left={0}
          gap={'48px'}
          height={isDesktop ? 'auto' : '100%'}
          maxWidth={'630px'}
          boxShadow={'0px 4px 28px rgba(45, 112, 217, 0.15)'}
          bgcolor={isDesktop ? 'primary.shade_100' : 'none'}
          borderRadius={isDesktop ? '16px' : '0'}
          padding={isDesktop ? '32px 32px 22px 32px' : '0'}
          tabIndex={0}
        >
          <Box
            component={'img'}
            src={isDesktop ? DisabledVeteranBg : DisabledVeteranBgMobile}
            position={'absolute'}
            top={isDesktop ? '0' : '-44px'}
            left={isDesktop ? '0' : '-24px'}
            width={isDesktop ? 'auto' : '100vw'}
          />
          {!isDesktop && (
            <Stack zIndex={1}>
              <LinkReturnToMain color='#fff' />
            </Stack>
          )}
          <Stack>
            <Avatar
              alt={''}
              src={HeaderIcons}
              sx={{
                width: '294px',
                height: '57px',
                alignSelf: isDesktop ? 'flex-start' : 'center',
              }}
            />
            <Stack
              marginTop={'59px'}
              marginBottom={'49px'}
              color={'#fff'}
              alignItems={'center'}
              position={'relative'}
            >
              <Typography
                aria-hidden='true'
                role='heading'
                variant={'h5'}
                tabIndex={0}
              >
                <span>{dictionary.title}</span>
              </Typography>
              <Typography
                aria-hidden='true'
                role='heading'
                variant={'h5'}
                tabIndex={0}
              >
                {dictionary.subtitle}
              </Typography>
              <Typography
                aria-hidden='true'
                role='heading'
                variant={'h5'}
                tabIndex={0}
              >
                {dictionary.subtitle2}
              </Typography>
            </Stack>
            <h1 className='sr-only'>
              {dictionary.title + ' ' + dictionary.subtitle}
            </h1>
            {disabledVeteran && (
              <Box
                position={'relative'}
                sx={
                  isDesktop
                    ? undefined
                    : {
                        width: '100%',
                        padding: '0 24px',
                        right: '24px',
                      }
                }
              >
                <DisabledVeteranPaper disabledVeteran={disabledVeteran} />
              </Box>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
